import React, {Component} from 'react';
import {connect} from "react-redux";
import {fetchingAllBatteriesSelector, allBatteriesSelector} from "../redux/reducers/allBatteriesReducer";
import {fetchingAllUsersSelector, allUsersSelector} from "../redux/reducers/allUsersReducer";
import {openBatteryIdSelector} from "../redux/reducers/openReducer";
import {fetchAllBatteries} from "../redux/actionCreators/allBatteries";
import {fetchAllUsers} from "../redux/actionCreators/allUsers";
import {dk_blue, dk_gray, dk_light_gray} from "../constants/style";
import {PulseLoader} from "react-spinners";
import MaterialIcon from "material-icons-react";
import NavLink from "react-router-dom/es/NavLink";
import {connectedSelector, userSelector} from "../redux/reducers/authReducer";
import strings from "../screenLocalisation/batteryInfo";
import {disconnect} from "../redux/actionCreators/auth";
import Autocomplete from 'react-autocomplete';
import {setOpenBattery} from "../redux/actionCreators/open";
import {fetchBatteryById} from "../redux/actionCreators/batteryById";
import {fetchUserById} from "../redux/actionCreators/userById";
import {fetchBatteryByIdWithState} from '../redux/actionCreators/batteryById';




class AdminTable extends Component {
    constructor(props){
        super(props)
        this.state = {
            value:'',
            adminActionSelected:'',
            filterTor:false,

        }
    }

    componentDidMount() {

    }

    render() {

        return (
            <div className={'adminTable'}>
                <div  className={'adminBattery'}>
                    <div className={'adminBatteryUsers'}>
                        <div>
                            <h3>{'Liste des batteries :'}</h3>
                        </div>
                        <div className={'filtreTor'} onClick={async ()=> {
                           const filter = await this.setState(prevState => ({
                                filterTor: !prevState.filterTor
                            }))
                            if(this.state.filterTor){
                                document.getElementById('checkBoxTorFilter').style.background = 'black'
                            } else {
                                document.getElementById('checkBoxTorFilter').style.background = 'white'
                            }

                        }}>Afficher défauts <span id={'checkBoxTorFilter'} className={'checkBoxTorFilter'}></span></div>
                    </div>
                    <div className={'rowAdminTable'}>
                        <div className={'labelAdminTableSn'}> SN</div>
                        <div className={'labelAdminTableSoc'}>SOC</div>
                        <div className={'labelAdminTableNoAlarm'}>alarm</div>
                        <div className={'labelAdminTableTor'}>TOR</div>
                    </div>
                {this.props.batteries.map((battery,index)=>{
                    if (this.state.filterTor === true && battery.batteryStates[0]) {
                        if (battery.batteryStates[0].tor_overchargedefault||battery.batteryStates[0].tor_tempdefault||battery.batteryStates[0].tor_commdefault||  battery.batteryStates[0].tor_underchargedefault) {
                            return (
                                <div key={battery.id} className={'rowAdminTable'}>

                                    <div className={'adminBatterySn'} onClick={()=>(this.props.fetchBatteryById(battery.id),this.props.setOpenBattery(battery.id),this.props.fetchBatteryByIdWithState(battery.id))}>{battery.sn}</div>
                                    {battery.batteryStates.map((b)=>{
                                        return (
                                            <div key={b.id} className={'adminTor'}>
                                                <div className={'dataGroupAdmin soc'}>
                                                    <div>{b.soc}</div>
                                                </div>
                                                <div className={'dataGroupAdmin noAlarm'}>
                                                    <div>{b.tor_noalarm?'non':'oui'}</div>
                                                </div>
                                                <div  className={'dataGroupAdmin dataGroupAdminTor'}>
                                                    <div className={'adminTorIcon'}>
                                                        {b.tor_overchargedefault ?
                                                            <img src={require('../assets/img/DEFAULT/OVERCHARGE_ON.png')}/> :
                                                            <img src={require('../assets/img/DEFAULT/OVERCHARGE_OFF.png')}/>}
                                                    </div>
                                                    <p>{strings.overcharge}</p>
                                                </div>

                                                <div className={'dataGroupAdmin dataGroupAdminTor'}>
                                                    <div className={'adminTorIcon'}>
                                                        {b.tor_underchargedefault ?
                                                            <img src={require('../assets/img/DEFAULT/UNDERCHARGE_ON.png')}/> :
                                                            <img src={require('../assets/img/DEFAULT/UNDERCHARGE_OFF.png')}/>}
                                                    </div>
                                                    <p>{strings.undercharge}</p>
                                                </div>

                                                <div  className={'dataGroupAdmin dataGroupAdminTor'}>
                                                    <div className={'adminTorIcon'}>
                                                        {b.tor_tempdefault ?
                                                            <img src={require('../assets/img/DEFAULT/OVERTEMP_ON.png')}/> :
                                                            <img src={require('../assets/img/DEFAULT/OVERTEMP_OFF.png')}/>}
                                                    </div>
                                                    <p>{strings.temperature}</p>
                                                </div>

                                                <div  className={'dataGroupAdmin dataGroupAdminTor'}>
                                                    <div className={'adminTorIcon'}>
                                                        {b.tor_commdefault ?
                                                            <img src={require('../assets/img/DEFAULT/COM_ERROR_ON.png')}/> :
                                                            <img src={require('../assets/img/DEFAULT/COM_ERROR_OFF.png')}/>}
                                                    </div>
                                                    <p>{strings.communication}</p>
                                                </div>
                                            </div>


                                        )
                                    })}

                                </div>
                            )
                        }
                    }
                    else {
                        return (

                            <div key={battery.id} className={'rowAdminTable'}>

                                <div className={'adminBatterySn'} onClick={()=>(this.props.fetchBatteryById(battery.id),this.props.setOpenBattery(battery.id),this.props.fetchBatteryByIdWithState(battery.id))}>{battery.sn}</div>
                                {battery.batteryStates.map((b)=>(
                                    <div key={b.id} className={'adminTor'}>
                                        <div className={'dataGroupAdmin soc'}>
                                            <div>{b.soc}</div>
                                        </div>
                                        <div className={'dataGroupAdmin noAlarm'}>
                                            <div>{b.tor_noalarm?"non":"oui"}</div>
                                        </div>
                                        <div  className={'dataGroupAdmin dataGroupAdminTor'}>
                                            <div className={'adminTorIcon'}>
                                                {b.tor_overchargedefault ?
                                                    <img src={require('../assets/img/DEFAULT/OVERCHARGE_ON.png')}/> :
                                                    <img src={require('../assets/img/DEFAULT/OVERCHARGE_OFF.png')}/>}
                                            </div>
                                            <p>{strings.overcharge}</p>
                                        </div>

                                        <div className={'dataGroupAdmin dataGroupAdminTor'}>
                                            <div className={'adminTorIcon'}>
                                                {b.tor_underchargedefault ?
                                                    <img src={require('../assets/img/DEFAULT/UNDERCHARGE_ON.png')}/> :
                                                    <img src={require('../assets/img/DEFAULT/UNDERCHARGE_OFF.png')}/>}
                                            </div>
                                            <p>{strings.undercharge}</p>
                                        </div>

                                        <div  className={'dataGroupAdmin dataGroupAdminTor'}>
                                            <div className={'adminTorIcon'}>
                                                {b.tor_tempdefault ?
                                                    <img src={require('../assets/img/DEFAULT/OVERTEMP_ON.png')}/> :
                                                    <img src={require('../assets/img/DEFAULT/OVERTEMP_OFF.png')}/>}
                                            </div>
                                            <p>{strings.temperature}</p>
                                        </div>

                                        <div  className={'dataGroupAdmin dataGroupAdminTor'}>
                                            <div className={'adminTorIcon'}>
                                                {b.tor_commdefault ?
                                                    <img src={require('../assets/img/DEFAULT/COM_ERROR_ON.png')}/> :
                                                    <img src={require('../assets/img/DEFAULT/COM_ERROR_OFF.png')}/>}
                                            </div>
                                            <p>{strings.communication}</p>
                                        </div>
                                    </div>


                                ))}

                            </div>
                        )
                    }
                   }

                )}
                </div>
            </div>
        );
    }
    swtichMenu() {
        switch(this.state.adminActionSelected)
        {
            case 'batteries':
                return <div>
                    <div className={'adminBackButton'} onClick={()=>this.setState({'adminActionSelected':''})}>Retour</div>
                    <Autocomplete
                        items={this.props.batteries}
                        inputProps={{
                            id: "search",
                            name: "search",
                            component: "input",
                            className: "fieldInputSearchBar"
                        }}
                        wrapperProps={{
                            className: "wrapperInputSearchBar"
                        }}
                        wrapperStyle={{display: 'flex', position: 'relative'}}
                        menuStyle={{
                            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                            background: 'rgba(255, 255, 255, 0.9)',
                            paddingLeft: "10px",
                            position: "fixed",
                            overflow: 'auto',
                            width: "100%",
                            maxWidth: "800px",
                            minWidth: "250px",
                            left: "0",
                            right: "0",
                            marginLeft: "auto",
                            marginRight: "auto",
                            maxHeight: '500px', // TODO: don't cheat, let it flow to the bottom
                        }}
                        shouldItemRender={(item, value) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        getItemValue={item => item.name}
                        renderItem={(item, highlighted) =>
                            <div
                                key={item.id}
                                style={{
                                    backgroundColor: highlighted ? '#FFCC00' : 'white',
                                    fontSize: "18px",
                                    paddingTop: "3px",
                                    paddingBottom: "3px"
                                }}
                            >
                                {item.sn}
                            </div>
                        }
                        value={this.state.value}
                        onChange={e => this.setState({value: e.target.value})}
                        onSelect={(value, item) => (this.setState({value}), this.props.fetchBatteryById(item.id)
                        )}
                        autoHighlight={true}
                    />
                </div>
            case 'users':
                return <div>
                    <div className={'adminBackButton'} onClick={()=>this.setState({'adminActionSelected':''})}>Retour</div>
                    <Autocomplete
                        items={this.props.users}
                        inputProps={{
                            id: "search",
                            name: "search",
                            component: "input",
                            className: "fieldInputSearchBar"
                        }}
                        wrapperProps={{
                            className: "wrapperInputSearchBar"
                        }}
                        wrapperStyle={{display: 'flex', position: 'relative'}}
                        menuStyle={{
                            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                            background: 'rgba(255, 255, 255, 0.9)',
                            paddingLeft: "10px",
                            position: "fixed",
                            overflow: 'auto',
                            width: "100%",
                            maxWidth: "800px",
                            minWidth: "250px",
                            left: "0",
                            right: "0",
                            marginLeft: "auto",
                            marginRight: "auto",
                            maxHeight: '500px', // TODO: don't cheat, let it flow to the bottom
                        }}
                        shouldItemRender={(item, value) => item.fullName.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        getItemValue={item => item.fullName}
                        renderItem={(item, highlighted) =>
                            <div
                                key={item.id}
                                style={{
                                    backgroundColor: highlighted ? '#FFCC00' : 'white',
                                    fontSize: "18px",
                                    paddingTop: "3px",
                                    paddingBottom: "3px"
                                }}
                            >
                                {item.fullName}
                            </div>
                        }
                        value={this.state.value}
                        onChange={e => this.setState({value: e.target.value})}
                        onSelect={async (value, item) => (this.setState({value}), this.props.fetchUserById(item.id))}
                        autoHighlight={true}
                    />
                </div>
            default:
                return null
        }
    }
}



const styles = {

    battery: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: 200,
        padding: 20,
    },
    batteryCharge: {
        color: 'white',
        margin: 0
    },
    batteryAlert: {
        flex: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
    },
    batteryLabel: {
        paddingRight: 20,
        flex: 5,
    },
    batteryInfos: {
        flex: 1,
    },
    loader: {
        margin: 20
    },
    userInfos: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    profileLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    connectIcon: {

    },
    userText: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'space=around',
        padding: '0 20px'
    },
    logoWrap: {
        height: 50
    },
    userTextP: {
        color: 'white'
    },
    profileInfo: {
        position: 'absolute',
        top: 5,
        right: 5
    }
}

const mapStateToProps = state => ({
    batteries: allBatteriesSelector(state),
    fetching: fetchingAllBatteriesSelector(state),
    connected: connectedSelector(state),
    user: userSelector(state),
    users: allUsersSelector(state),
    fetchingUsers: fetchingAllUsersSelector(state),
})

export default connect(mapStateToProps, {fetchAllBatteries,fetchAllUsers,setOpenBattery, disconnect, fetchBatteryById,fetchUserById,fetchBatteryByIdWithState})(AdminTable);